module.exports = __webpack_public_path__ + "static/media/navigate_next_white_24dp.5e54adcf.svg";